import * as React from 'react';
import './EligibleTab.scss';

import FiltersBarDesktop from '../FiltersBarDesktop';
import EligibleRowDesktop from './components/EligibleRowDesktop';
import TableHeader from 'src/components/common/TableHeader';
import EligibleRowMobile from './components/EligibleRowMobile';
import FiltersBarMobile from '../FiltersBarMobile';
import ResultsCounter from '../ResultsCounter';
import Alertcomp from 'src/components/common/Alert';
import { Alert } from '@material-ui/lab';
import { IconButton, Tooltip } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
import {
  IEligibleResponse,
  IEligibleItem,
  IReturnAlert
} from 'src/services/returns/typings';
import Loader from 'src/components/common/Loader';
import TablePagination from 'src/components/common/TablePagination';
import InvoiceService from 'src/services/invoice';
import { downloadFile } from 'src/utils/downloadHelper';
import localeFormatingInstance from 'src/translation/localeFormating';
import ToggleModal from './components/ToggleModal';
import { IToggleModalOptions } from '../../ReturnsView';
import i18n from 'src/translation/i18n';
import CustomPaginator from 'src/components/common/CustomPaginator';
import Button from '@material-ui/core/Button';
import exportIcon from '../../../../assets/export';
import downarrowIcon from '../../../../assets/downArrow';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import Downloadloader from 'src/components/common/Downloadloader';
import LocaleFormating from 'src/translation/localeFormating';
import returnsService from 'src/services/returns/returnsService';
interface IEligibleTabProps {
  eligibleData: IEligibleResponse;
  returnIsPending: boolean;
  partsToReturn: IEligibleItem[];
  handlePagination: (type: string) => void;
  handleSortItems: (option: string) => void;
  sortBy: string[];
  setSortEligible: (values: string[]) => void;
  handleShowCartModal: (status: boolean) => void;
  handleChangeTab: (index: number) => void;
  selectedTypeOfItem: string;
  handleSelectedTypeOfItemChange: (type: any) => void;
  selectedDates: any;
  setSelectedDates: (date: any) => void;
  handleDateChange: (date: any) => void;
  handleClickSearch: (searchBy: string, query: string) => void;
  returnAlert: IReturnAlert;
  closeAlert: () => void;
  showCounter: boolean;
  forItem: string;
  clearFilters: () => void;
  toggleModalOptions: IToggleModalOptions;
  handleDesktopPaginationEligible?(event: any): void;
  handlePageSizeChangeEligible?(event: any): void;
  handleMenuItemClick: (event: any, index:number) => void;
}

const EligibleTab: React.FC<IEligibleTabProps> = props => {
  const {
    eligibleData,
    returnIsPending,
    handlePagination,
    handleSortItems,
    sortBy,
    setSortEligible,
    selectedTypeOfItem,
    handleSelectedTypeOfItemChange,
    selectedDates,
    setSelectedDates,
    handleDateChange,
    handleClickSearch,
    partsToReturn,
    handleShowCartModal,
    returnAlert,
    closeAlert,
    showCounter,
    forItem,
    clearFilters,
    handleChangeTab,
    toggleModalOptions,
    handleDesktopPaginationEligible,
    handlePageSizeChangeEligible,
    handleMenuItemClick,
  } = props;

  const [selectedSearchBy, setSelectedSearchBy] = React.useState<string>(
    'partNumber'
  );
  const [searchQuery, setSearchQuery] = React.useState<string>('');
  const [hideShowPdfError, setHideShowPdfError] = React.useState(false);
  const [hideShowLoader, setHideShowLoader] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showLoaderOnAction, setShowLoaderOnAction] = React.useState(false);

  const exportOptions = [
    { label: `${i18n.t('invoices.exportasXLSX')}`, value: 'xlsx' },
    { label: `${i18n.t('invoices.exportasPDF')}`, value: 'pdf' },
    { label: `${i18n.t('invoices.exportasCSV')}`, value: 'csv' }
  ];


  React.useEffect(() => {
    setSearchQuery(forItem);
    return () => {
      closeAlert();
    };
  }, [forItem]);


  const handleSelectedSearchBy = (searchBy: string) => {
    setSelectedSearchBy(searchBy);
  };

  const handleSearchQuery = (str: string) => {
    setSearchQuery(str);
  };

  const onClickSearch = () => {
    handleClickSearch(selectedSearchBy, searchQuery);
  };

  const getInvoicePreview = (invoiceNumber: number, invoiceDate: string) => {
    setHideShowLoader(true);
    // window.scrollTo({ top: 0, behavior: 'smooth' });
    InvoiceService.downloadInvoice(String(invoiceNumber), String(invoiceDate))
      .then((response: any) => {
        downloadFile(
          response.data,
          `invoice-${invoiceNumber}-${localeFormatingInstance.getNowDate(
            'short'
          )}.pdf`
        );
        setHideShowLoader(false);
      })
      .catch(error => {
        console.log(error);
        setHideShowLoader(false);
        setHideShowPdfError(true);
        // window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  };
  const closeErrorMsgHandler = () => {
    setHideShowPdfError(false);
  };

  const handleClickListItem = (event: any) => {
     setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClickPre=(event:any,index:number)=>{
    setAnchorEl(null);
    handleMenuItemClick(event,index)
  }

  
  const headers = [
    {
      id: 'partNumber',
      name: `${i18n.t('myReturns.partNo')}`,
      spaces: 2,
      isSortable: true
    },
    {
      id: 'invoiceNumber',
      name: `${i18n.t('myReturns.invoiceNo')}`,
      spaces: 1,
      isSortable: true
    },
    {
      id: 'invoiceDate',
      name: `${i18n.t('myReturns.invoiceDate')}`,
      spaces: 1,
      isSortable: true
    },
    {
      id: 'price',
      name: `${i18n.t('myReturns.price')}`,
      spaces: 1,
      isSortable: false
    },
    {
      id: 'returnQty',
      name: `${i18n.t('myReturns.returnQty')}`,
      spaces: 1,
      isSortable: false
    },
    {
      id: 'restockingFee',
      name: `${i18n.t('myReturns.restockingFee')}`,
      spaces: 1,
      isSortable: false
    },
    {
      id: 'reason',
      name: `${i18n.t('myReturns.reasonReference')}`,
      spaces: 3,
      isSortable: false
    },
    {
      id: 'options',
      name: '',
      spaces: 2,
      isSortable: false
    }
  ];


  return (
    <>
      {returnIsPending ? (
        <Loader />
      ) : (
        <div className="rp-eligible-tab">
          {toggleModalOptions.show && (
            <ToggleModal
              handleGranted={toggleModalOptions.onGranted}
              handleCancel={toggleModalOptions.onCancel}
            />
          )}
          {returnAlert.show && (
            <Alertcomp
              type={returnAlert.type}
              styleClass="rp-eligible-tab-desktop-alert"
              message={returnAlert.message}
              icon={returnAlert.icon}
              handleCloseAlert={closeAlert}
              hasRouteHandler={true}
              goToTab={() => handleChangeTab(1)}
              linkText={'Go To Return Status'}
            />
          )}

          <div className="rp-eligible-tab-desktop">
            <FiltersBarDesktop
              typeOfItemOptions={[
                { value: 'part', label: `${i18n.t('myReturns.part')}` },
                { value: 'usedCore', label: `${i18n.t('myReturns.usedCore')}` }
              ]}
              selectedTypeOfItem={selectedTypeOfItem}
              onSelectedTypeOfItemChange={handleSelectedTypeOfItemChange}
              dates={selectedDates}
              onDatesChange={handleDateChange}
              searchByOptions={[
                { value: 'partNumber', label: `${i18n.t('myReturns.partNo')}` },
                {
                  value: 'invoiceNumber',
                  label: `${i18n.t('myReturns.invoiceNo')}`
                }
              ]}
              selectedSearchBy={selectedSearchBy}
              onSelectedSearchByChange={handleSelectedSearchBy}
              searchQuery={searchQuery}
              onSearchQueryChange={handleSearchQuery}
              onSearchButtonClick={onClickSearch}
              itemsLength={partsToReturn.length}
              returnCartAction={() => handleShowCartModal(true)}
            />

            {showCounter && (
              <ResultsCounter
                clearFilters={clearFilters}
                resultsQuantity={eligibleData.totalElements}
                item={forItem}
                targetSearchField={selectedSearchBy}
              />
            )}

          {eligibleData.data.length >0 &&
          <span className="export-icon-return-menu"> 
            <Button
              aria-controls="fade-menu"
              aria-haspopup="true"
              onClick={handleClickListItem}
              disabled={null}
            >
              <img className="image-icon" src={exportIcon} />
              <img className="down-arrow" src={downarrowIcon} />
            </Button>
            </span>
            }
            {eligibleData.data.length >0 &&
            <Menu
              id="fade-menu"
              anchorEl={anchorEl}
              keepMounted={true}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              TransitionComponent={Fade}
            >
              {exportOptions.map((exportoptions, index) => (
                <MenuItem
                  key={exportoptions.value}
                  // selected={index === index}
                  onClick={event => handleMenuItemClickPre(exportoptions.value, index)}
                >
                  {exportoptions.label}
                </MenuItem>
              ))}
            </Menu>
            }

            {eligibleData.data.length > 0 && (
              <>
                <div className="rp-product-eligible--paginator">
                  <CustomPaginator
                    activePage={
                      eligibleData?.pageNumber ? eligibleData.pageNumber + 1 : 1
                    }
                    totalPages={eligibleData?.totalPages}
                    itemsPerPage={eligibleData?.pageSize}
                    onPageChanged={handleDesktopPaginationEligible}
                    totalItems={
                      eligibleData?.totalPages * eligibleData?.pageSize
                    }
                    showPageInfo={true}
                    onPageSizeChange={handlePageSizeChangeEligible}
                    showPageRangeChange={true}
                    currentPageSize={eligibleData?.pageSize}
                  />
                </div>
                
                <TableHeader
                  headers={headers}
                  handleSortBy={handleSortItems}
                  sortBy={sortBy}
                />
              
              </>
            )}
            {eligibleData.data.map(eligible => (
              <EligibleRowDesktop
                key={eligible.id}
                eligibleItem={eligible}
                loaderStatus={hideShowLoader}
                hideShowMsgStatus={hideShowPdfError}
              />
            ))}
            <div className="rp-product-eligible--paginator">
              <CustomPaginator
                activePage={
                  eligibleData?.pageNumber ? eligibleData.pageNumber + 1 : 1
                }
                totalPages={eligibleData?.totalPages}
                itemsPerPage={eligibleData?.pageSize}
                onPageChanged={handleDesktopPaginationEligible}
                totalItems={eligibleData?.totalPages * eligibleData?.pageSize}
                showPageInfo={true}
                onPageSizeChange={handlePageSizeChangeEligible}
                showPageRangeChange={true}
                currentPageSize={eligibleData?.pageSize}
              />
            </div>
            
          </div>
          <div className="rp-eligible-tab-mobile">
            <div className="rp-eligible-tab-mobile-filterbar">
              <h2 className="rp-eligible-tab-heading">Eligible for Return</h2>
              <FiltersBarMobile
                typeOfItemOptions={[
                  { value: 'part', label: `${i18n.t('myReturns.part')}` },
                  {
                    value: 'usedCore',
                    label: `${i18n.t('myReturns.usedCore')}`
                  }
                ]}
                selectedTypeOfItem={selectedTypeOfItem}
                onSelectedTypeOfItemChange={handleSelectedTypeOfItemChange}
                searchByOptions={[
                  {
                    value: 'partNumber',
                    label: `${i18n.t('myReturns.partNo')}`
                  },
                  {
                    value: 'invoiceNumber',
                    label: `${i18n.t('myReturns.invoiceNo')}`
                  }
                ]}
                selectedSearchBy={selectedSearchBy}
                onSelectedSearchByChange={handleSelectedSearchBy}
                dates={selectedDates}
                setDates={setSelectedDates}
                searchQuery={searchQuery}
                onSearchQueryChange={handleSearchQuery}
                onSearchButtonClick={onClickSearch}
                sortBy={sortBy}
                setSortBy={setSortEligible}
                itemsLength={partsToReturn.length}
                returnCartAction={() => handleShowCartModal(true)}
              />
            </div>

            {showCounter && (
              <ResultsCounter
                clearFilters={clearFilters}
                resultsQuantity={eligibleData.totalElements}
                item={forItem}
                targetSearchField={selectedSearchBy}
              />
            )}
          
            <div className="rp-eligible-mobile-table-paginator">
            {eligibleData.data.length >0 &&
          <span className="export-icon-return-menu"> 
            <Button
              aria-controls="fade-menu"
              aria-haspopup="true"
              onClick={handleClickListItem}
              disabled={null}
            >
              <img className="image-icon" src={exportIcon} />
              <img className="down-arrow" src={downarrowIcon} />
            </Button>
            </span>
            }
            {eligibleData.data.length >0 &&
            <Menu
              id="fade-menu"
              anchorEl={anchorEl}
              keepMounted={true}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              TransitionComponent={Fade}
            >
              {exportOptions.map((exportoptions, index) => (
                <MenuItem
                  key={exportoptions.value}
                  // selected={index === index}
                  onClick={event => handleMenuItemClickPre(exportoptions.value, index)}
                >
                  {exportoptions.label}
                </MenuItem>
              ))}
            </Menu>
            }
              <TablePagination
                handlePagination={handlePagination}
                pagination={{
                  pageNumber: eligibleData.pageNumber,
                  pageSize: eligibleData.pageSize,
                  totalPages: eligibleData.totalPages
                }}
              />
            </div>
            <div className="rp-eligible-tab-mobile-rows">
              {eligibleData.data.map(eligible => (
                <EligibleRowMobile key={eligible.id} eligibleItem={eligible} />
              ))}
            </div>
          </div>
          <div className="rp-eligible-mobile-table-paginator">
            <TablePagination
              handlePagination={handlePagination}
              pagination={{
                pageNumber: eligibleData.pageNumber,
                pageSize: eligibleData.pageSize,
                totalPages: eligibleData.totalPages
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default EligibleTab;
